import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CompanyResponse } from '@features/company/company.model';
import { ClientCompanyRequest, ClientCompanyResponse } from '../../client.model';

@Component({
  selector: 'app-client-company-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './client-company-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientCompanyFormComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly clientId = input.required<string>();
  readonly companies = input<CompanyResponse[]>([]);
  readonly initialValue = input<ClientCompanyResponse | null>(null);
  readonly saving = input(false);
  readonly submitted = output<ClientCompanyRequest>();

  readonly clientCompanyForm = this.formBuilder.group({
    companyId: ['', Validators.required],
    uniqueCompanyCode: ['', Validators.required],
    companyClientCode: [''],
  });

  constructor() {
    effect(() => {
      const initialValue = this.initialValue();
      if (initialValue) {
        this.clientCompanyForm.patchValue({
          companyId: initialValue.companyId,
          uniqueCompanyCode: initialValue.uniqueCompanyCode,
          companyClientCode: initialValue.companyClientCode ?? '',
        });
      }
    });
  }

  protected onSubmit(): void {
    if (this.clientCompanyForm.invalid) {
      return;
    }

    const value = this.clientCompanyForm.getRawValue();
    this.submitted.emit({
      clientId: this.clientId(),
      companyId: value.companyId ?? '',
      uniqueCompanyCode: value.uniqueCompanyCode ?? '',
      companyClientCode: value.companyClientCode?.trim() ? value.companyClientCode : null,
    });
  }
}